module.exports = __webpack_public_path__ + "static/media/farmdokMockAppleMobileApplicationDE.ed5191bf.webp";